import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const Route = createFileRoute('/_private-routes/asset-preview')({
  staticData: {
    menuTitle: MenuTitle.AssetPreview
  }
});
